$( document ).ready(function() {
    $('#button_approval_accept_top').on("click", function () {
        if (UpdateInspectionStatuses(GetSelectedInspections(), 'FEE-OPTION')) {
            console.log('success updating inspections to APPROVED');
        } else {
            // failure
            console.log('failed updating inspections');
        }
    });

// set the selected inspections to withdrawn status
    $('#button_approval_withdraw_top').on("click", function () {
        if (UpdateInspectionStatuses(GetSelectedInspections(), 'WITHDRAWN')) {
            console.log('success updating inspections to WITHDRAWN');
        } else {
            // failure
            console.log('failed updating inspections');
        }
    });

// set the selected inspections to dispute status
    $('#button_approval_dispute_top').on("click", function () {
        if (UpdateInspectionStatuses(GetSelectedInspections(), 'REVIEW')) {
            console.log('success updating inspections to REVIEW');

        } else {
            // failure
            console.log('failed updating inspections');
        }
    });

    // allows the user to remove the HOLD status from the vehicles
    // which will trigger the approval system
    $('#button_hold_release_top').on("click", function () {
        if (UpdateInspectionStatuses(GetSelectedInspections(), 'PENDING')) {
            console.log('success releasing the selected vehicles from HOLD');

        } else {
            // failure
            console.log('failed updating inspections');
        }
    });

    // allows the user to remove the REVIEW status from the vehicle
    // which will trigger the approval system
    $('#button_review_release_top').on("click", function () {
        if (UpdateInspectionStatuses(GetSelectedInspections(), 'PENDING')) {
            console.log('success releasing the selected vehicles from REVIEW');

        } else {
            // failure
            console.log('failed updating inspections');
        }
    });

    /*
    ----------------------
    Above is an indicator for the old top buttons... deprecated soon for inline buttons
    -----------------------
     */

// set the selected inspections to accepted status
    $('.button_approval_accept').on("click", function (event) {
        var inspection_id = $(event.currentTarget).data('inspection-id');
        if (UpdateInspectionStatuses([inspection_id], 'FEE-OPTION')) {
            console.log('success updating inspections to APPROVED');
        } else {
            // failure
            console.log('failed updating inspections');
        }
    });

// set the selected inspections to withdrawn status
    $('.button_approval_withdraw').on("click", function () {
        var inspection_id = $(event.currentTarget).data('inspection-id');
        if (UpdateInspectionStatuses([inspection_id], 'WITHDRAWN')) {
            console.log('success updating inspections to WITHDRAWN');
        } else {
            // failure
            console.log('failed updating inspections');
        }
    });

// set the selected inspections to dispute status
    $('.button_approval_dispute').on("click", function (event) {
        var inspection_id = $(event.currentTarget).data('inspection-id');
        if (UpdateInspectionStatuses([inspection_id], 'REVIEW')) {
            console.log('success updating inspections to REVIEW');

        } else {
            // failure
            console.log('failed updating inspections');
        }
    });

    // allows the user to remove the HOLD status from the vehicles
    // which will trigger the approval system
    $('.button_hold_release').on("click", function (event) {
        var inspection_id = $(event.currentTarget).data('inspection-id');
        if (UpdateInspectionStatuses([inspection_id], 'PENDING')) {
            console.log('success releasing the selected vehicles from HOLD');

        } else {
            // failure
            console.log('failed updating inspections');
        }
    });

    // allows the user to remove the REVIEW status from the vehicle
    // which will trigger the approval system
    $('.button_review_release').on("click", function (event) {
        var inspection_id = $(event.currentTarget).data('inspection-id');
        if (UpdateInspectionStatuses([inspection_id], 'PENDING')) {
            console.log('success releasing the selected vehicles from REVIEW');

        } else {
            // failure
            console.log('failed updating inspections');
        }
    });

    // get the associated ids for print to pdf
    $('.button_approval_view_cr').on("click", function (event) {
        var ele = $(event.target);
        var results = GetSelectAdsIdsWithInspectionType();
        var ads_ids = results[0];
        var inspection_ids=GetSelectedInspections();
        var inspection_type = results[1];
        var public_status = "false";
        var notes_user = "true";
        var aim_cr_url = ele.data('aimCrUrl');
        var state_code = String(ele.data('stateCode'));
        var data = {
            'inspection_type': inspection_type,
            'state_code': state_code
        };
        var endpoint = '/reports/v2/cr';

        if (inspection_type === 'fca-gdp') {
            data["vp_guids"] = inspection_ids;
        }
        else if (inspection_type === 'fmcc'){
            data["ads_guids"] = ads_ids;
            data["public_status"] = public_status;
            data["notes_user"] = notes_user;
            endpoint = '/reports/v2/fmcc_pdf';
        }
        else {
            data["ads_guids"] = ads_ids;
        }

        send_request_to_download_file("POST", aim_cr_url + endpoint, data);
    });

    $('#export_excel_button').on("click", function () {
        count = parseInt($('#hidden-queryset-count').val());
        if (count == 0 || $('#hidden-queryset-count').length == 0){
            return;
        }
        export_excel_url = updateQueryStringParameter(window.location.href, 'export_excel', '1');
        window.open(export_excel_url)
    });

    //Used to add a query parameter to url
    function updateQueryStringParameter(uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf('?') !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, '$1' + key + "=" + value + '$2');
        }
        else {
            return uri + separator + key + "=" + value;
        }
    }

// returns an array of the inspection ids that have selected checkboxes
    function GetSelectedInspections() {
        var inspection_id_array = [];

        $('.checkbox-inspection').each(function () {
            if ($(this).prop('checked')) {
                inspection_id_array.push($(this).attr('id'));
            }
        });

        // returns an error if the array isn't populated
        if (inspection_id_array.length == 0) {
            alert('Select inspections using the checkboxes!');
            return 0;
        } else {
            return inspection_id_array;
        }
    }

    function GetSelectAdsIdsWithInspectionType(){
        var ads_ids = [];
        var inspection_type = $('.checkbox-inspection:checked').data('inspectionType');

        $('.checkbox-inspection').each(function () {
            if ($(this).prop('checked')) {
                ads_ids.push($(this).data('adsId'));
            }
        });

        // returns an error if the array isn't populated
        if (ads_ids.length === 0) {
            alert('Select inspections using the checkboxes!');
        } else {
            return [ads_ids, inspection_type];
        }
    }

// ajax call to server that updates the inspection status to the new one
// for each of the inspection ids that is part of the array
    function UpdateInspectionStatuses(inspection_id_array, inspection_status) {
        // for each value in the array
        // update the status
        var result = true;
        var i = 0;

        for (i; i < inspection_id_array.length; i++) {

            var json_msg = {
                id: inspection_id_array[i],
                status_code: inspection_status
            };

            $.ajax({
                method: "POST",
                url: "/inspections/status-update",
                data: JSON.stringify(json_msg)
            }).done(function (msg) {
                result = true;
                console.log('successful ajax response: ' + msg);

                if (msg.error) {
                    snackbar_msg = msg.error;
                    snackbar_timeout = 5000;

                    var options = {
                        text: snackbar_msg, // text of the snackbar
                        duration: snackbar_timeout, // time in milliseconds after the snackbar autohides, 0 is disabled
                        showAction: false
                    };

                    Snackbar.show(options);

                }
                location.reload();

            });

        }

        return result;

    }

});